export const NexusRoutes = {
  EcosystemOverview: '/ecosystem_overview/',
  GromaCoinOverview: '/gromacoin/overview/',
  Properties: '/properties/',
  PropertyDetails: (id: number) => `/properties/${id}/`,
  PropertyFinancials: (id: number) => `/properties/${id}/financials/`,
};
